/**
 * Theme Loader Utility
 * Dynamically loads theme settings from backend and injects CSS variables
 */

export const loadTheme = async () => {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.ogestyle.com';
    const response = await fetch(`${API_BASE_URL}/api/admin/settings/public`);
    const data = await response.json();
    
    if (data.success && data.settings.themeSettings) {
      applyTheme(data.settings.themeSettings);
    }
  } catch (error) {
    // Fallback to default theme (already in CSS)
  }
};

export const applyTheme = (themeSettings) => {
  const root = document.documentElement;
  
  // Apply font family
  if (themeSettings.fontFamily) {
    root.style.setProperty('--font-family-primary', themeSettings.fontFamily);
  }
  
  // Apply font sizes
  if (themeSettings.fontSize) {
    Object.entries(themeSettings.fontSize).forEach(([key, value]) => {
      root.style.setProperty(`--font-size-${key}`, value);
    });
  }
  
  // Apply font weights
  if (themeSettings.fontWeight) {
    Object.entries(themeSettings.fontWeight).forEach(([key, value]) => {
      root.style.setProperty(`--font-weight-${key}`, value);
    });
  }
  
  // Apply colors
  if (themeSettings.colors) {
    Object.entries(themeSettings.colors).forEach(([key, value]) => {
      // Convert camelCase to kebab-case for CSS variables
      const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      root.style.setProperty(`--color-${cssKey}`, value);
    });
    
    // Create the gradient CSS variable
    if (themeSettings.colors.primaryGradientStart && themeSettings.colors.primaryGradientEnd) {
      root.style.setProperty(
        '--color-primary-gradient', 
        `linear-gradient(135deg, ${themeSettings.colors.primaryGradientStart} 0%, ${themeSettings.colors.primaryGradientEnd} 100%)`
      );
    }
  }
};
